import React from "react"
import {Button} from 'reactstrap';
import General from "./data/General"

class Quiz extends React.Component {
    constructor() {
        super()
        this.state = {
            count: 0,
            played:0,
            done:false,
            first:false,
            zero: 0,
            one: 0,
            two: 0,
        }
        this.handleRight = this.handleRight.bind(this)
        this.handleWrong = this.handleWrong.bind(this)
        this.handleLoad = this.handleLoad.bind(this)
    }
    
    handleRight() {
        this.setState(prevState => {
            return {
                count: 2,
                played: 1,
                done:true,
                first:false
            }
        })
    }

    handleWrong() {
      this.setState(prevState => {
          return {
              count: 1,
              played: 1,
              done:true,
              first:false
          }
      })
  }

  handleLoad() {

    var mixed = [0,1,2]
    mixed.sort(() => Math.random() - 0.5);

    this.setState(prevState => {
      return {
          zero: mixed[0],
          one: mixed[1],
          two: mixed[2],
      }
  })
}

  componentDidMount(){
    this.handleLoad();
  }
    
    render() {
      let score = <p>&nbsp;</p>
      let button1 = <Button className={`quizbutton ${this.state.played===1 ? 'btn-success': ''}`} disabled={this.state.done} onClick={this.handleRight} color="secondary" style={{ marginBottom: '1rem' }}>{this.props.persona}</Button>
      let button2 = <Button className="quizbutton" disabled={this.state.done} onClick={this.handleWrong} color="secondary" style={{ marginBottom: '1rem' }}>{this.props.personb}</Button>
      let button3 = <Button className="quizbutton" disabled={this.state.done} onClick={this.handleWrong} color="secondary" style={{ marginBottom: '1rem' }}>{this.props.personc}</Button>

      let arr = [button1, button2, button3];

      if (this.state.count===2){
          score=<div><p className="right">{General[9].chapterAR}</p><em>{this.props.persona} {this.props.notes}</em></div>
        }
        else if(this.state.count===1){
          score=<div><p className="wrong">{General[10].chapterAR}</p><em>{this.props.persona} {this.props.notes}</em></div>
        }
        return (
        <div className="quizbox">
        <h3 className="gray strong text-center">{General[5].chapterAR}</h3>
        <br/>
        <p className="gray text-center"><em>"{this.props.quote}"</em></p>
        <br/>

        <p className="text-center">
        {arr[this.state.zero]}
        {arr[this.state.one]}
        {arr[this.state.two]}
        {score}
        </p>
        </div>
        )
    }
}

export default Quiz